<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11ECc03/images/frontcover.jpg?1705668005017" alt="This image is the cover for the book Foul Deeds & Suspicious Deaths in Liverpool, Foul Deeds & Suspicious Deaths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foul Deeds & Suspicious Deaths in Liverpool, Foul Deeds & Suspicious Deaths
      </h1>
      <p class="bookDescription body article font2">
        <b>The disturbing, criminal history of Britain’s “World Capital City of Pop”—home of murderers, thieves, bodysnatchers . . . and The Beatles.</b><br/>  <br/> The city of Liverpool, England, was like every other city energized by the Victorian boon in industry and trade. It is best known today as the home of the British Invasion and music that changed the world. But Liverpool’s history has a less harmonious side, and a dark past that reaches back centuries. True crime historian, Stephen Wade, goes there.<br/>  <br/> In <i>Foul Deeds &amp; Suspicious Deaths in Liverpool</i>, Wade reveals the city’s most shocking crimes: a notoriously deadly duel in 1806; gang wars and the infamous nineteenth-century “Cholera Riots”; a killer butcher and a terrorist bombing; grandma killers and sinister sisters; swindlers and crimes of passion; poisonings, bodysnatchers, and serial killers; a murderer who claimed to be possessed by demons; and a terrifying hunt for the fiend behind the Ripper murders. Wade invites readers into the shadowy backstreets of a fabled city in this criminally fascinating chronicle of misdeeds, madmen, and real-life mysteries.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Wade
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wharncliffe
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0abe0e25